// Piccoli helper di formattazione condivisi fra le pagine.
// Nati per eliminare tre copie identiche di getInitials che, su nomi con spazi
// doppi o iniziali/finali, producevano avatar tipo "IUNDEFINED".

/**
 * Iniziali per gli avatar, a prova di spazi multipli e stringhe vuote.
 *   "  ACME   SPA "  -> "AS"
 *   "Acme"           -> "AC"
 *   ""/null          -> "?"
 */
export function iniziali(nome) {
  const parole = String(nome || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parole.length === 0) return '?';
  if (parole.length === 1) return parole[0].substring(0, 2).toUpperCase();
  return (parole[0][0] + parole[1][0]).toUpperCase();
}

/**
 * Concorda il sostantivo con il numero: plurale(1,'cantiere','cantieri') -> "1 cantiere".
 */
export function plurale(n, singolare, plurali) {
  return `${n} ${n === 1 ? singolare : plurali}`;
}
